import { myExternalEventApi } from '../../../api/external-event/external-event-api.connected';
import { createEventService } from './EventService.impl';

export const myEventService = createEventService(myExternalEventApi);
